export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टिकरण आवश्यक है"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्राधिकरण को एक-बार कुंजी से पुष्टि करनी होगी"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्राधिकरण को जादुई शब्द से पुष्टि करनी होगी"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पंजीकरण को एसएमएस संदेश से कोड द्वारा पुष्टि करनी होगी"])}
}